module.exports = require("@splunk/visualization-context/IconRegistry");